import { ActivatedRoute } from '@angular/router';
import { Itinerary, Day } from './../itineray.model';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-itinerary-day-info',
  templateUrl: './itinerary-day-info.component.html',
  styleUrls: ['./itinerary-day-info.component.css']
})
export class ItineraryDayInfoComponent implements OnInit {

  itinerary: Itinerary;

  day: Day;

  dayId: number;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.itinerary = this.route.parent.parent.snapshot.data.itinerary;
    this.route.parent.params.subscribe(params => {
      this.dayId = parseInt(params["dayId"]) - 1;
      this.day = this.itinerary.days[this.dayId];
    });
  }

}
